module.exports = __webpack_public_path__ + "static/media/battery.2dd61395.svg";